import { Order, Address } from '../types';
import { Order as ApiOrder } from '../../../api/orders';

export function formatPhoneNumber(phone: string): string {
    if (!phone || phone === '-') return '-';
    // Remove all non-digit characters
    let digits = phone.replace(/\D/g, '');

    // Handle +66 format (convert to 0)
    if (digits.startsWith('66') && digits.length === 11) {
        digits = '0' + digits.slice(2);
    }

    // Format as 08x-xxx-xxxx (10 digits)
    if (digits.length === 10) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phone;
}

export function mapApiOrderToView(order: ApiOrder): Order {
    const shippingLabelPrinted = Boolean(order.trackingNumber);

    const mapStatus = (): Order['status'] => {
        const status = order.status;
        // Orders with 'shipped' or 'delivered' status are considered 'printed'
        if (status === 'shipped' || status === 'delivered' || status === 'printed') {
            return 'printed';
        }
        if (shippingLabelPrinted) {
            return 'printed';
        }
        // Preserve 'paid' status (ready to print)
        if (status === 'paid') {
            return 'paid';
        }
        return 'pending';
    };

    const paymentStatus = (order.paymentStatus === 'paid' || order.paymentStatus === 'successful') ? 'paid' : 'pending';

    const items = (order.items || []).map((item: any) => ({
        id: item.id || item.productId || Math.random().toString(),
        productName: item.productName || 'สินค้า',
        quantity: item.quantity || 1,
        price: item.unitPrice || item.subtotal || 0,
        variant: item.variantName,
    }));

    const shippingAddress: Address = {
        fullName: order.shippingName || 'ลูกค้า',
        phone: formatPhoneNumber(order.shippingPhone || '-'),
        address: order.shippingAddressLine1 || '-',
        district: order.shippingDistrict || '-',
        province: order.shippingProvince || '-',
        postalCode: order.shippingPostalCode || '-',
    };

    return {
        id: order.id,
        orderNumber: order.orderNumber || order.id,
        customerName: shippingAddress.fullName,
        customerPhone: shippingAddress.phone,
        totalAmount: order.total || 0,
        paymentMethod: order.paymentMethod,
        status: mapStatus(),
        createdAt: typeof order.createdAt === 'string' ? order.createdAt : (order.createdAt instanceof Date ? order.createdAt.toISOString() : new Date().toISOString()),
        items,
        shippingAddress,
        paymentStatus,
        shippingLabelPrinted,
        trackingNumber: order.trackingNumber || null,
        // Financial fields
        subtotal: order.subtotal || 0,
        shippingCost: order.shippingCost || 0,
        paymentFee: order.paymentFee || 0,
        // Discount fields
        deliveryDiscountAmount: order.deliveryDiscountAmount || 0,
        secretDealDiscountAmount: order.secretDealDiscountAmount || 0,
        secretDealDiscountPercent: order.secretDealDiscountPercent || 0,
        loyaltyDiscountAmount: order.loyaltyDiscountAmount || 0,
        loyaltyDiscountPercent: order.loyaltyDiscountPercent || 0,
        totalDiscountAmount: order.totalDiscountAmount || 0,
        isSecretDeal: order.isSecretDeal || false,
    };
}
